module.exports = __webpack_public_path__ + "static/media/map_continents.49d1e5ce.png";